<template>
    <v-menu v-if="$store.state.selectedAcademy" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-flex class="clickable" v-bind="attrs" v-on="on" text-xs-center layout align-center justify-center>
                <v-avatar size="42" class="grey lighten-4 clickable">
                    <ImageDisplay v-if="$store.state.userImage" :src="$store.state.userImage" alt="avatar" />
                    <v-avatar size="36" color="plusIndigoLighten3" v-else>
                        <span class="font-roboto white--text text-subtitle-1">{{
                            getInitials(`${$store.state.user.fName} ${$store.state.user.lName}`)
                        }}</span>
                    </v-avatar>
                </v-avatar>
            </v-flex>
        </template>
        <v-list class="pa-0 flex flex-column">
            <v-list-item v-if="!$store.state.inApp">
                <v-list-item-title class="d-flex align-center justify-space-between">
                    <span class="mr-7 font-roboto text-body-1">{{
                        $t('message.dark_mode') }}</span>

                    <v-switch v-model="localDarkTheme" @change="onThemeSwitch" inset dense color="plusIndigoDarken4" />

                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="showNewDesignToggle" class="d-flex">
                <v-list-item-title class="d-flex align-center">
                    <span class="mr-7 font-roboto text-body-1">{{ $t('message.new_design') }}</span>
                    <v-switch v-model="localAdminPlusVersion" @change="onAdminPlusSwitch" inset dense
                        color="plusIndigoDarken4" />
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openFeedbackDialog">
                <v-list-item-title class="font-roboto text-body-1">
                    {{ $t("message.feedback") }}
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openTechSupport">
                <v-list-item-title class="font-roboto text-body-1">
                    {{ $t("message.tech_support") }}
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.state.inApp" @click="logout">
                <v-list-item-title class="font-roboto text-body-1">
                    {{ $t("message.logout") }}
                </v-list-item-title>
            </v-list-item>
            <v-list-item @click="reloadAndRefresh(true)">
                <v-list-item-title class="font-roboto text-body-1">
                    Version v{{ appVersion }}
                    <span v-if="isSystemAdmin()" class="ml-1">[InApp: {{ $store.state.inApp }}]</span>
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isSystemAdmin()" @click="copyToClipboard($store.state.managedAcademy)">
                <v-list-item-title class="font-roboto text-body-1">
                    <v-icon>mdi-fingerprint</v-icon>
                    ManagedAcademy ID
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isSystemAdmin()" @click="copyToClipboard($store.state.selectedAcademy)">
                <v-list-item-title class="font-roboto text-body-1">
                    <v-icon>mdi-fingerprint</v-icon>
                    Academy ID
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isSystemAdmin() && stripeAccountId" @click="copyToClipboard(stripeAccountId)">
                <v-list-item-title class="font-roboto text-body-1">
                    <v-icon>mdi-fingerprint</v-icon>
                    Stripe Account ID
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    props: {
        darkTheme: Boolean,
        appVersion: String,
        stripeAccountId: String,
    },
    data() {
        return {
            localDarkTheme: this.darkTheme,
            localAdminPlusVersion: this.$store.state.adminPlusVersion,
        };
    },
    computed: {
        showNewDesignToggle() {
            return true
            // const status = this.$store.state.academyAdminStatus;
            // return status && status?.settings?.adminPlusVersion === false;
        },
    },
    watch: {
        darkTheme(val) {
            this.localDarkTheme = val;
        },
        '$store.state.adminPlusVersion'(val) {
            this.localAdminPlusVersion = val;
        }
    },
    methods: {
        assets(path) {
            return require(`@/assets/${path}`);
        },
        isAppAdmin() {
            return this.$store.state.isAppAdmin;
        },
        onThemeSwitch() {
            this.$emit('toggle-theme', this.localDarkTheme);
        },
        onAdminPlusSwitch() {
            this.$emit('toggle-admin-plus', this.localAdminPlusVersion);
        },
        openFeedbackDialog() {
            this.$emit('open-feedback');
        },
        openTechSupport() {
            this.$emit('open-tech-support');
        },
        logout() {
            this.$emit('logout');
        },
        reloadAndRefresh(releases) {
            this.$emit('reload-refresh', releases);
        },
        copyToClipboard(value) {
            this.$emit('copy', value);
        },
    },
};
</script>
